/**
 * CinderRot Community — vanilla JS, esbuild-bundled/minified to
 * community.min.js for production (see build.js; run `npm run build`
 * after editing this file, from cinderrot/cinderrot-wp/). The plugin
 * itself still ships zero runtime dependencies — the Node toolchain is
 * a dev-time-only build step, not a plugin dependency.
 */
( function () {
	'use strict';

	function toast( message, isError ) {
		var el = document.querySelector( '.cr-toast' );
		if ( ! el ) {
			el = document.createElement( 'div' );
			el.className = 'cr-toast';
			document.body.appendChild( el );
		}
		el.textContent = message;
		el.classList.toggle( 'is-error', !! isError );
		el.classList.add( 'is-visible' );
		clearTimeout( el._timer );
		el._timer = setTimeout( function () {
			el.classList.remove( 'is-visible' );
		}, 3000 );
	}

	function apiFetch( path, options ) {
		options = options || {};
		options.headers = Object.assign( {}, options.headers, {
			'X-WP-Nonce': window.cinderrotCommunity.nonce,
		} );
		return fetch( window.cinderrotCommunity.restUrl + path, options ).then( function ( res ) {
			return res.json().then( function ( data ) {
				if ( ! res.ok ) {
					var err = new Error( data.message || 'Request failed' );
					err.data = data;
					throw err;
				}
				return data;
			} );
		} );
	}

	function requireLogin() {
		toast( 'Sign in to do that' );
		setTimeout( function () {
			window.location.href = window.cinderrotCommunity.loginUrl;
		}, 900 );
	}

	// ── Likes ──────────────────────────────────────────────────────────────
	document.addEventListener( 'click', function ( e ) {
		var btn = e.target.closest( '.cr-like-btn' );
		if ( ! btn ) return;

		if ( ! window.cinderrotCommunity.isLoggedIn ) {
			requireLogin();
			return;
		}

		var fitId = btn.dataset.fitId;
		var countEl = btn.querySelector( '.cr-like-count' );
		var wasLiked = btn.classList.contains( 'is-liked' );

		// Optimistic UI
		btn.classList.toggle( 'is-liked' );
		btn.classList.add( 'cr-like-pulse' );
		countEl.textContent = parseInt( countEl.textContent, 10 ) + ( wasLiked ? -1 : 1 );
		setTimeout( function () { btn.classList.remove( 'cr-like-pulse' ); }, 300 );

		apiFetch( 'fits/' + fitId + '/like', { method: 'POST' } )
			.then( function ( data ) {
				countEl.textContent = data.count;
				btn.classList.toggle( 'is-liked', data.liked );
			} )
			.catch( function () {
				// Roll back on failure
				btn.classList.toggle( 'is-liked', wasLiked );
				countEl.textContent = parseInt( countEl.textContent, 10 ) + ( wasLiked ? 1 : -1 );
				toast( 'Could not update like — try again', true );
			} );
	} );

	// ── Vote casting ─────────────────────────────────────────────────────────
	document.addEventListener( 'click', function ( e ) {
		var btn = e.target.closest( '.cr-vote-option' );
		if ( ! btn || btn.disabled ) return;

		if ( ! window.cinderrotCommunity.isLoggedIn ) {
			requireLogin();
			return;
		}

		var dropId   = btn.dataset.dropId;
		var designId = btn.dataset.designId;
		var card     = btn.closest( '.cr-vote-drop-card' );

		apiFetch( 'votes/' + dropId + '/' + designId, { method: 'POST' } )
			.then( function ( data ) {
				var total = data.designs.reduce( function ( sum, d ) { return sum + d.vote_count; }, 0 );
				card.querySelectorAll( '.cr-vote-option' ).forEach( function ( optionBtn ) {
					var d = data.designs.find( function ( x ) { return x.id === optionBtn.dataset.designId; } );
					if ( ! d ) return;
					var pct = total > 0 ? Math.round( ( d.vote_count / total ) * 100 ) : 0;
					optionBtn.querySelector( '.cr-vote-option__bar span' ).style.width = pct + '%';
					optionBtn.querySelector( '.cr-vote-option__pct' ).textContent = pct + '%';
					optionBtn.classList.toggle( 'is-voted', d.id === data.user_vote );
				} );
				toast( 'Vote cast!' );
			} )
			.catch( function ( err ) {
				toast( err.message || 'Could not cast vote', true );
			} );
	} );

	// ── Fit upload modal & Dropzone (Roadmap Items 113 & 118) ────────────────
	var openBtn          = document.getElementById( 'cr-post-fit-btn' );
	var modal            = document.getElementById( 'cr-fit-upload-modal' );
	var closeBtn         = document.getElementById( 'cr-fit-upload-close' );
	var form             = document.getElementById( 'cr-fit-upload-form' );
	var fileInput        = document.getElementById( 'cr-fit-file-input' );
	var dropzone         = document.getElementById( 'cr-fit-dropzone' );
	var dzPrompt         = document.getElementById( 'cr-fit-dropzone-prompt' );
	var previewContainer = document.getElementById( 'cr-fit-preview-container' );
	var previewImg       = document.getElementById( 'cr-fit-preview-img' );
	var previewWrapper   = document.getElementById( 'cr-fit-preview-wrapper' );
	var taggingLayer     = document.getElementById( 'cr-fit-tagging-layer' );
	var taggingPanel     = document.getElementById( 'cr-fit-tagging-panel' );
	var tagInput         = document.getElementById( 'cr-fit-tag-input' );
	var tagAddBtn        = document.getElementById( 'cr-fit-tag-add-btn' );
	var tagCancelBtn     = document.getElementById( 'cr-fit-tag-cancel-btn' );
	var changePhotoBtn   = document.getElementById( 'cr-fit-change-photo-btn' );
	var tagsHiddenInput  = document.getElementById( 'cr-fit-pinpoint-tags-input' );

	var pinpointTags = [];
	var pendingPin = null;

	if ( openBtn && modal ) {
		openBtn.addEventListener( 'click', function () {
			modal.hidden = false;
			document.body.style.overflow = 'hidden';
		} );
	}
	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', closeModal );
	}
	if ( modal ) {
		modal.addEventListener( 'click', function ( e ) {
			if ( e.target === modal ) closeModal();
		} );
	}
	function closeModal() {
		modal.hidden = true;
		document.body.style.overflow = '';
	}

	function handleFileSelected( file ) {
		if ( ! file ) return;
		var maxBytes = ( window.cinderrotCommunity.maxUploadMb || 10 ) * 1024 * 1024;
		if ( file.size > maxBytes ) {
			toast( 'That image is too large — max ' + window.cinderrotCommunity.maxUploadMb + 'MB', true );
			if ( fileInput ) fileInput.value = '';
			return;
		}

		var reader = new FileReader();
		reader.onload = function ( e ) {
			if ( previewImg ) previewImg.src = e.target.result;
			if ( dzPrompt ) dzPrompt.hidden = true;
			if ( previewContainer ) previewContainer.hidden = false;
			if ( dropzone ) dropzone.classList.add( 'has-preview' );
			pinpointTags = [];
			updatePinpointLayer();
		};
		reader.readAsDataURL( file );
	}

	if ( fileInput ) {
		fileInput.addEventListener( 'change', function () {
			if ( fileInput.files && fileInput.files[0] ) {
				handleFileSelected( fileInput.files[0] );
			}
		} );
	}

	// Drag and drop event listeners
	if ( dropzone ) {
		[ 'dragenter', 'dragover' ].forEach( function ( evt ) {
			dropzone.addEventListener( evt, function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				dropzone.classList.add( 'is-dragover' );
			} );
		} );

		[ 'dragleave', 'drop' ].forEach( function ( evt ) {
			dropzone.addEventListener( evt, function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				dropzone.classList.remove( 'is-dragover' );
			} );
		} );

		dropzone.addEventListener( 'drop', function ( e ) {
			var dt = e.dataTransfer;
			if ( dt && dt.files && dt.files[0] ) {
				fileInput.files = dt.files;
				handleFileSelected( dt.files[0] );
			}
		} );
	}

	if ( changePhotoBtn ) {
		changePhotoBtn.addEventListener( 'click', function ( e ) {
			e.stopPropagation();
			if ( fileInput ) fileInput.value = '';
			if ( previewImg ) previewImg.src = '';
			if ( previewContainer ) previewContainer.hidden = true;
			if ( dzPrompt ) dzPrompt.hidden = false;
			if ( dropzone ) dropzone.classList.remove( 'has-preview' );
			if ( taggingPanel ) taggingPanel.hidden = true;
			pinpointTags = [];
			pendingPin = null;
			updatePinpointLayer();
		} );
	}

	// Fit Pinpoint Tag Placement (Roadmap Item 113)
	if ( previewWrapper ) {
		previewWrapper.addEventListener( 'click', function ( e ) {
			if ( ! previewImg || ! previewImg.src || e.target.closest( '.cr-fit-pin-remove' ) ) return;
			var rect = previewWrapper.getBoundingClientRect();
			var x = ( ( e.clientX - rect.left ) / rect.width ) * 100;
			var y = ( ( e.clientY - rect.top ) / rect.height ) * 100;

			pendingPin = {
				x: Math.round( Math.max( 0, Math.min( 100, x ) ) * 10 ) / 10,
				y: Math.round( Math.max( 0, Math.min( 100, y ) ) * 10 ) / 10,
			};

			if ( taggingPanel ) taggingPanel.hidden = false;
			if ( tagInput ) {
				tagInput.value = '';
				tagInput.focus();
			}
			renderPendingPin();
		} );
	}

	function renderPendingPin() {
		var existingTemp = taggingLayer.querySelector( '.cr-fit-pin--temp' );
		if ( existingTemp ) existingTemp.remove();
		if ( ! pendingPin ) return;

		var tempPin = document.createElement( 'div' );
		tempPin.className = 'cr-fit-pin cr-fit-pin--temp';
		tempPin.style.left = pendingPin.x + '%';
		tempPin.style.top = pendingPin.y + '%';
		tempPin.innerHTML = '<span class="cr-fit-pin__dot"></span><span class="cr-fit-pin__pulse"></span>';
		taggingLayer.appendChild( tempPin );
	}

	function updatePinpointLayer() {
		if ( ! taggingLayer ) return;
		taggingLayer.innerHTML = '';
		pinpointTags.forEach( function ( pt, idx ) {
			var pin = document.createElement( 'div' );
			pin.className = 'cr-fit-pin';
			pin.style.left = pt.x + '%';
			pin.style.top = pt.y + '%';
			pin.innerHTML = '<span class="cr-fit-pin__dot"></span>' +
				'<div class="cr-fit-pin__badge">' + escapeHtml( pt.label ) +
				'<button type="button" class="cr-fit-pin-remove" data-index="' + idx + '" aria-label="Remove tag">&times;</button></div>';
			taggingLayer.appendChild( pin );
		} );

		if ( tagsHiddenInput ) {
			tagsHiddenInput.value = JSON.stringify( pinpointTags );
		}

		taggingLayer.querySelectorAll( '.cr-fit-pin-remove' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', function ( e ) {
				e.stopPropagation();
				var index = parseInt( btn.dataset.index, 10 );
				pinpointTags.splice( index, 1 );
				updatePinpointLayer();
			} );
		} );
	}

	if ( tagAddBtn && tagInput ) {
		tagAddBtn.addEventListener( 'click', function () {
			var label = tagInput.value.trim();
			if ( ! label || ! pendingPin ) return;
			pinpointTags.push( {
				x: pendingPin.x,
				y: pendingPin.y,
				label: label,
			} );
			pendingPin = null;
			taggingPanel.hidden = true;
			updatePinpointLayer();
		} );
	}

	if ( tagCancelBtn ) {
		tagCancelBtn.addEventListener( 'click', function () {
			pendingPin = null;
			renderPendingPin();
			if ( taggingPanel ) taggingPanel.hidden = true;
		} );
	}

	// ── Caption character counter (Roadmap item 114) ───────────────────────────
	var captionEl   = document.getElementById( 'cr-fit-caption' );
	var charCountEl = document.getElementById( 'cr-caption-counter' );
	if ( captionEl && charCountEl ) {
		captionEl.addEventListener( 'input', function () {
			var len = captionEl.value.length;
			charCountEl.textContent = len + '/280';
			if ( len >= 280 ) {
				charCountEl.className = 'cr-char-counter is-max';
			} else if ( len >= 250 ) {
				charCountEl.className = 'cr-char-counter is-warning';
			} else {
				charCountEl.className = 'cr-char-counter';
			}
		} );
	}

	if ( form ) {
		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();
			var submitBtn = document.getElementById( 'cr-fit-submit-btn' ) || form.querySelector( 'button[type="submit"]' );
			submitBtn.disabled = true;
			submitBtn.textContent = 'Posting…';

			var formData = new FormData( form );

			fetch( window.cinderrotCommunity.restUrl + 'fits', {
				method: 'POST',
				headers: { 'X-WP-Nonce': window.cinderrotCommunity.nonce },
				body: formData,
			} )
				.then( function ( res ) {
					return res.json().then( function ( data ) {
						if ( ! res.ok ) throw new Error( data.message || 'Upload failed' );
						return data;
					} );
				} )
				.then( function ( data ) {
					toast( data.message || 'Fit posted — pending review' );
					closeModal();
					form.reset();
					if ( charCountEl ) {
						charCountEl.textContent = '0/280';
						charCountEl.className = 'cr-char-counter';
					}
					if ( previewImg ) previewImg.src = '';
					if ( previewContainer ) previewContainer.hidden = true;
					if ( dzPrompt ) dzPrompt.hidden = false;
					if ( dropzone ) dropzone.classList.remove( 'has-preview' );
					pinpointTags = [];
					pendingPin = null;
					updatePinpointLayer();
				} )
				.catch( function ( err ) {
					toast( err.message, true );
				} )
				.finally( function () {
					submitBtn.disabled = false;
					submitBtn.textContent = 'Post fit';
				} );
		} );
	}

	// ── Feed Controls: Tabs, Multi-Tribe Filter & Sort (Roadmap Item 127) ──────
	var tabs = document.querySelectorAll( '.cr-community__tab' );
	var tribePills = document.querySelectorAll( '.cr-tribe-pill-btn' );
	var sortSelect = document.getElementById( 'cr-community-sort' );
	var gridEl = document.getElementById( 'cr-community-grid' );
	var emptyEl = document.getElementById( 'cr-community-empty' );

	var currentFeed = 'all';
	var selectedTribes = [];
	var currentSort = 'date';

	function escapeHtml( str ) {
		return ( str || '' ).replace( /[&<>"']/g, function ( m ) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[ m ];
		} );
	}

	function refreshFeed() {
		if ( gridEl ) {
			gridEl.style.opacity = '0.4';
			gridEl.style.pointerEvents = 'none';
		}

		var params = new URLSearchParams();
		params.set( 'feed', currentFeed );
		params.set( 'orderby', currentSort );
		if ( selectedTribes.length > 0 ) {
			params.set( 'tribes', selectedTribes.join( ',' ) );
		}

		apiFetch( 'fits?' + params.toString(), { method: 'GET' } )
			.then( function ( res ) {
				if ( ! gridEl ) return;
				var fits = res.fits || [];
				if ( fits.length === 0 ) {
					gridEl.innerHTML = '';
					gridEl.style.display = 'none';
					if ( emptyEl ) {
						emptyEl.style.display = 'block';
						var msgEl = emptyEl.querySelector( 'p:last-child' );
						if ( msgEl ) {
							msgEl.textContent = 'No fits found matching your filter ritual — be the first to post.';
						}
					}
				} else {
					if ( emptyEl ) emptyEl.style.display = 'none';
					gridEl.style.display = 'grid';
					var html = '';
					fits.forEach( function ( fit ) {
						var likedClass = fit.has_liked ? ' is-liked' : '';
						var likedFill = fit.has_liked ? 'currentColor' : 'none';
						var tribeHtml = fit.tribe ? '<span class="cr-fit-card__tribe">' + escapeHtml( fit.tribe ) + '</span>' : '';
						
						var hotspotsHtml = '';
						if ( fit.pinpoint_tags && fit.pinpoint_tags.length > 0 ) {
							hotspotsHtml = '<div class="cr-fit-hotspots">';
							fit.pinpoint_tags.forEach( function( pt ) {
								hotspotsHtml += '<div class="cr-fit-hotspot" style="left:' + pt.x + '%; top:' + pt.y + '%;">' +
									'<button type="button" class="cr-fit-hotspot__pin" aria-label="Tagged Artifact">' +
									'<span class="cr-fit-hotspot__pulse"></span><span class="cr-fit-hotspot__dot"></span>' +
									'</button>' +
									'<div class="cr-fit-hotspot__popover">' +
									'<a href="' + ( pt.url || '#' ) + '" class="cr-fit-hotspot__link">' + escapeHtml( pt.label || 'Artifact' ) + ' →</a>' +
									'</div></div>';
							} );
							hotspotsHtml += '</div>';
						}

						html += '<article class="cr-fit-card" data-fit-id="' + fit.id + '">' +
							'<div class="cr-fit-card__media-wrap">' +
							'<a href="' + ( fit.permalink || '#' ) + '" class="cr-fit-card__media">' +
							'<img src="' + ( fit.image_url || '' ) + '" alt="' + escapeHtml( fit.title ) + '" loading="lazy" />' +
							tribeHtml +
							'</a>' +
							hotspotsHtml +
							'</div>' +
							'<div class="cr-fit-card__footer">' +
							'<span class="cr-fit-card__author">@' + escapeHtml( fit.author || 'coven' ) + '</span>' +
							'<button class="cr-like-btn' + likedClass + '" data-fit-id="' + fit.id + '" aria-pressed="' + ( fit.has_liked ? 'true' : 'false' ) + '">' +
							'<svg width="14" height="14" viewBox="0 0 24 24" fill="' + likedFill + '" stroke="currentColor" stroke-width="2">' +
							'<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
							'</svg>' +
							'<span class="cr-like-count">' + ( fit.like_count || 0 ) + '</span>' +
							'</button>' +
							'</div>' +
							'</article>';
					} );
					gridEl.innerHTML = html;
					initLazyImages();
				}
			} )
			.catch( function () {
				toast( 'Could not refresh feed', true );
			} )
			.finally( function () {
				if ( gridEl ) {
					gridEl.style.opacity = '1';
					gridEl.style.pointerEvents = 'auto';
				}
			} );
	}

	tabs.forEach( function ( tab ) {
		tab.addEventListener( 'click', function () {
			if ( tab.classList.contains( 'is-active' ) ) return;
			tabs.forEach( function ( t ) {
				t.classList.remove( 'is-active' );
				t.setAttribute( 'aria-selected', 'false' );
			} );
			tab.classList.add( 'is-active' );
			tab.setAttribute( 'aria-selected', 'true' );
			currentFeed = tab.dataset.feed || 'all';
			refreshFeed();
		} );
	} );

	tribePills.forEach( function ( pill ) {
		pill.addEventListener( 'click', function () {
			var slug = pill.dataset.tribeSlug;
			if ( ! slug ) return;
			var isActive = pill.classList.contains( 'is-active' );
			if ( isActive ) {
				pill.classList.remove( 'is-active' );
				pill.setAttribute( 'aria-pressed', 'false' );
				selectedTribes = selectedTribes.filter( function ( s ) { return s !== slug; } );
			} else {
				pill.classList.add( 'is-active' );
				pill.setAttribute( 'aria-pressed', 'true' );
				selectedTribes.push( slug );
			}
			refreshFeed();
		} );
	} );

	if ( sortSelect ) {
		sortSelect.addEventListener( 'change', function () {
			currentSort = sortSelect.value;
			refreshFeed();
		} );
	}

	// ── Live Vote-Drop Real-Time Activity & Polling Ticker (Roadmap Item 128) ──
	function initVoteActivityTickers() {
		var tickers = document.querySelectorAll( '.cr-vote-activity-ticker' );
		if ( ! tickers.length ) return;

		tickers.forEach( function ( ticker ) {
			var dropId = ticker.dataset.dropId || '0';
			var textEl = ticker.querySelector( '.cr-vote-activity-text' );
			var dotEl = ticker.querySelector( '.cr-vote-activity-dot' );
			var activityIndex = 0;
			var cachedActivity = [];

			function fetchActivity() {
				apiFetch( 'votes/' + dropId + '/activity?limit=5', { method: 'GET' } )
					.then( function ( res ) {
						if ( res && res.activity && res.activity.length > 0 ) {
							cachedActivity = res.activity;
							displayNextActivity();
						}
					} )
					.catch( function () {
						// Fail gracefully without interrupting UI
					} );
			}

			function displayNextActivity() {
				if ( ! textEl || cachedActivity.length === 0 ) return;
				var item = cachedActivity[ activityIndex % cachedActivity.length ];
				activityIndex++;

				textEl.style.opacity = '0';
				if ( dotEl ) dotEl.classList.add( 'is-pulsing' );

				setTimeout( function () {
					textEl.textContent = item.user + ' cast a vote for "' + item.design_name + '" (' + item.time_ago + ')';
					textEl.style.opacity = '1';
					if ( dotEl ) {
						setTimeout( function () { dotEl.classList.remove( 'is-pulsing' ); }, 1000 );
					}
				}, 250 );
			}

			// Initial fetch
			setTimeout( fetchActivity, 800 + Math.random() * 1000 );

			// Poll for fresh votes every 14 seconds
			setInterval( fetchActivity, 14000 );

			// Rotate between cached activities every 4.5 seconds
			setInterval( function () {
				if ( cachedActivity.length > 1 ) {
					displayNextActivity();
				}
			}, 4500 );
		} );
	}

	// ── Mobile Pull-to-Refresh for Community Feed (Roadmap Item 144) ────────────
	function initPullToRefresh() {
		var communityEl = document.getElementById( 'cr-community' );
		var indicatorEl = document.getElementById( 'cr-pull-indicator' );
		if ( ! communityEl || ! indicatorEl ) return;

		var startY = 0;
		var currentY = 0;
		var isPulling = false;
		var threshold = 70;

		communityEl.addEventListener( 'touchstart', function ( e ) {
			if ( window.scrollY <= 0 && e.touches.length === 1 ) {
				startY = e.touches[0].clientY;
				isPulling = true;
			}
		}, { passive: true } );

		communityEl.addEventListener( 'touchmove', function ( e ) {
			if ( ! isPulling || window.scrollY > 0 ) return;
			currentY = e.touches[0].clientY;
			var diff = currentY - startY;

			if ( diff > 0 ) {
				var distance = Math.min( 90, diff * 0.45 );
				indicatorEl.style.height = distance + 'px';
				indicatorEl.style.opacity = Math.min( 1, distance / 40 );
				var rot = Math.min( 180, distance * 2 );
				var sigil = indicatorEl.querySelector( '.cr-pull-sigil' );
				if ( sigil ) {
					sigil.style.transform = 'rotate(' + rot + 'deg)';
				}
				if ( distance >= threshold ) {
					indicatorEl.classList.add( 'is-ready' );
				} else {
					indicatorEl.classList.remove( 'is-ready' );
				}
			}
		}, { passive: true } );

		communityEl.addEventListener( 'touchend', function () {
			if ( ! isPulling ) return;
			isPulling = false;
			var diff = currentY - startY;
			var distance = Math.min( 90, diff * 0.45 );

			if ( distance >= threshold ) {
				indicatorEl.classList.add( 'is-refreshing' );
				indicatorEl.style.height = '50px';
				if ( typeof window.cinderrotHaptic === 'function' ) {
					window.cinderrotHaptic( [ 15, 20 ] );
				}
				refreshFeed();
				setTimeout( function () {
					indicatorEl.classList.remove( 'is-refreshing', 'is-ready' );
					indicatorEl.style.height = '0';
					indicatorEl.style.opacity = '0';
				}, 1200 );
			} else {
				indicatorEl.classList.remove( 'is-ready' );
				indicatorEl.style.height = '0';
				indicatorEl.style.opacity = '0';
			}
			startY = 0;
			currentY = 0;
		}, { passive: true } );
	}

	// ── IntersectionObserver Lazy Loading for Community Feed (Roadmap item 18) ──
	function initLazyImages() {
		if ( ! ( 'IntersectionObserver' in window ) ) return;
		var lazyImages = document.querySelectorAll( '.cr-fit-card__media img:not(.is-observed)' );
		if ( lazyImages.length === 0 ) return;

		var observer = new IntersectionObserver( function ( entries, obs ) {
			entries.forEach( function ( entry ) {
				if ( entry.isIntersecting ) {
					var img = entry.target;
					img.classList.add( 'is-revealed' );
					obs.unobserve( img );
				}
			} );
		}, { rootMargin: '120px 0px' } );

		lazyImages.forEach( function ( img ) {
			img.classList.add( 'is-observed' );
			observer.observe( img );
		} );
	}

	initVoteActivityTickers();
	initPullToRefresh();
	initLazyImages();
} )();
